import axios from "axios";
import qs from 'qs'
import mime from 'mime'
import { store } from "Store/store.index";
import { baseUrlApis } from "./index";
import { URL_PLATFORM, DATA_TYPE, CONVERT_TIME_LIMIT/*, CONVERT_TYPE*/ } from './constants'
import { HttpRequest } from './request.utils'
import cuid from "cuid";
import { doExport } from 'Utils/utils';
import md5 from 'crypto-js/md5';

const commonToken = 'phantomOnline'
const WebToolAPIs = {
    baseUrl: "",
    baseHttpUrl: "",
    upload: "platform/api/doc",
    convert: "platform/api/doc/convert",
    taskStatus: "platform/api/task",
    download: "platform/api/download",
    downloadZip: "platform/api/downloadzip"
};


function _GetPlatformToken(flag){
    const { allowNoSignIn } = store.userStore

    if (allowNoSignIn) {
        return commonToken;
    }
    if (!flag) {
        return store.userStore.token;
    }
    // 8003 5dbf8cd15764542e96a30fcb
    // 8081 5dbf8765a09af17dfce13d76
    return '5dbf986c603d5c6237f37ea0';
}

/** 
 * 
 * 
 */

export class ConvertApis extends HttpRequest {
    constructor() {
        super();
        this.CPDFURI = '';
    }
    initialize = () => {
        try {
            baseUrlApis.getBaseUrlBy(URL_PLATFORM).then((data) => {
                this.CPDFURI = data;
                // 8003 8081
                //this.CPDFURI = 'http://10.103.4.236:8003';
                let axiosClient = axios.create({
                    baseURL: this.CPDFURI,
                });
                super.initialize(axiosClient, () => {
                    this.interceptorsFn();
                });
                //interceptorsFn(this.apisAxios);
            });
        } catch (error) {
            throw error;
        }
    }
    doGetRequest = async (url, callback) => {
        let result = await this.get({ url });
        if (result && result.ret != void 0) {
            callback && callback(result);
            return;
        }
        throw result;
    }

    /**
     * @param {FileData} fileData  
     * @returns {{ ret:Number, data: Object }} result, result.data.docid is {string} 
     * @memberof ConvertApis
     */
    // ! 转换、pdf优化减少文件大小等功能会先上传文件。。
    doUpload = async (fileData, onUploadCallback, cancelCallback) => {
        let url = `/${WebToolAPIs.upload}?access_token=${_GetPlatformToken()}`;
        let fd = new FormData();
        switch (fileData.dataType) {
            case DATA_TYPE.File: {
                fd.append('file', fileData.file);
                break;
            }
            case DATA_TYPE.FileBuffer: {
                let data = (fileData.file instanceof Array) ? fileData.file : [fileData.file];
                let fileName = fileData.fileName;
                let docExt = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                let type = mime.getType(docExt);
                let blob = new Blob(data, {type});
                fd.append('filename', fileData.fileName)
                fd.append('file', blob, fileName);
                break;
            }
            case DATA_TYPE.Url: { break; }
            default: { break; }
        }
        const source = this.getCancelSource()
        const config = {
            onUploadProgress: function(progressEvent) {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                
                onUploadCallback && onUploadCallback(percentCompleted);
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            cancelToken: source.token
        }
        cancelCallback && cancelCallback(source);
        try {
            let result = await this.post({ url, data: fd, config});
            
            //let result = response?response.data:null;
            if (result && result.ret == 0) {
                // const data = result.data;
                
                //let token = data.access_token;
                return Promise.resolve(result);
            }
            throw result;
        } catch (error) {
            console.error("TCL: ConvertApis -> doUpload -> error", error)
            throw error;
        }


    }

    /**
     *
     * @param {Object[]} docList, object format is {docid,password},...
     * @param {string} docList.docid
     * @param {string} docList.password
     * @returns {Object} result {ret,data:{taskid}}
     * @memberof ConvertApis
     */
    doConvert = async (docList, convertType, cfg) => {
        // TODO cfg
        const headers = cfg && cfg.headers
        // post
        let data;
        const { allowNoSignIn } = store.userStore
        
        if(docList && docList.length !== 0){
            data = Object.assign({ documents: docList }, cfg);
            allowNoSignIn && Object.assign(data, { sign: md5(`${commonToken}${docList[0].docid}POdfD8JD46DU`).toString() })
        }else{
            data = cfg;
        }
        // WebToolAPIs.convert = platform/api/doc/convert
        // let token = store.userNewStore.userData.userToken
        // let urlHead = `https://online.foxitsoftware.cn/${WebToolAPIs.convert}`
        // let url = `${urlHead}?access_token=${token}&type=${convertType}`;
        let url = `/${WebToolAPIs.convert}?access_token=${_GetPlatformToken()}&type=${convertType}`;
        let result = await this.post({ url, data, config: { headers } });
        //let result = response?response.data:null;
        if (result && result.ret == 0) {
            return Promise.resolve(result);
        }
        return result;
    }

    /**
     * @private
     */
    _checkTaskStatus = (url, callback, taskId) => {
        const limit = CONVERT_TIME_LIMIT * 60;
        let count = 0;
        let lastPercent = 0;
        let isContinue;
        isContinue = store.taskStore.isContinueToConvert(taskId);
        if (!isContinue) {
            return;
        }
        let handler = window.setInterval(() => {
            isContinue = store.taskStore.isContinueToConvert(taskId);
            if (!isContinue) {
                window.clearInterval(handler);
                handler = null;
                return;
            }
            this.doGetRequest(url, (result) => {
                if (!handler) {
                    return;
                }
                // ret == 1, converting
                if (!result || result.ret === 1) {
                    //{"ret":1,"msg":"","data":{"percentage":5}}
                    if (result.ret === 1 && result.data) {
                        let percentage = result.data.percentage >= 0 ? result.data.percentage : 0;
                        if (lastPercent !== percentage) {
                            lastPercent = percentage;
                            count = 0;
                        } else {
                            count++;
                        }
                    } else {
                        count++;
                    }
                    // overtime, 10 mins
                    if (!!count && count * 2 > limit) {
                        window.clearInterval(handler);
                        handler = null;
                        result.ret = 87000001;
                        callback(result);
                    }
                    isContinue = store.taskStore.isContinueToConvert(taskId);
                    if (!isContinue) {
                        window.clearInterval(handler);
                        handler = null;
                    }
                    return;
                }
                // { "ret": "0", "message": "SUCCESS", "data": { "percentage": 100 }}
                // TODO: server has not finish percentage
                if (result.ret != 0 || (result.ret == 0)) {// && result.data.percentage === 100
                    window.clearInterval(handler);
                    handler = null;
                    callback(result);
                }
            }, (error) => {
                if (!handler) {
                    return;
                }
                console.error("TCL: ConvertApis -> _monitor -> error", error);
                window.clearInterval(handler);
                callback(error);
            })
        }, 2000);
    }
    /**
     * @param {Function} callback  
     *
     * @memberof ConvertApis
     */
    doMonitorStatus = (taskId, callback) => {
        // get
        let data = qs.stringify({
            taskid: taskId,
            random: cuid()
        });
        let url = `/${WebToolAPIs.taskStatus}?access_token=${_GetPlatformToken()}&${data}`;
        let _cb = (result) => {
            if (result.ret == 0) {
                let fileName=result.data.title?result.data.title:"";
                store.taskStore.htmlFileName=fileName;
                let fileUrl = this.doGetDownloadUrl(result.data.docid);
                result.url = fileUrl;
            }
            callback(result);
        }
        this._checkTaskStatus(url, _cb, taskId);
    }

    doGetDownloadUrl = (docid,filename='stream') => {
        // get  docid
        let url
        let data = {
            docid: docid,
            filename,
            random: cuid()
        };
        const { allowNoSignIn } = store.userStore

        allowNoSignIn && Object.assign(data, { sign: md5(`${commonToken}${docid}POdfD8JD46DU`).toString() })
        data = qs.stringify(data)
        url = `${this.CPDFURI}/${WebToolAPIs.download}?access_token=${_GetPlatformToken()}&${data}`;
        
        return url;
    }

    doGetDownloadXml = (docid, filename = 'xml') => {
        // get  docid
        let url
        let data = {
            docid,
            filename,
            random: cuid()
        };
        const { allowNoSignIn } = store.userStore

        allowNoSignIn && Object.assign(data, { sign: md5(`${commonToken}${docid}POdfD8JD46DU`).toString() });
        data = qs.stringify(data);
        url = `${this.CPDFURI}/${WebToolAPIs.download}?access_token=${_GetPlatformToken()}&${data}`;
        return url;
    }

    //多文件转pdf下载压缩包
    doDownloadZipPost= (docid, returnBlob) => {
        let datas ={
            data:JSON.stringify(docid),
            filename:'PDF Files.zip'
        };
        let url = `${this.CPDFURI}/${WebToolAPIs.downloadZip}?access_token=${_GetPlatformToken()}`;

        if (!returnBlob) {
            //form表单提交下载压缩包
            doExport(url,"post",datas);

            return
        }

        return this.doGetConvertedFileZipPackage(url, JSON.stringify(docid))
    }
    doGetConvertedFileZipPackage = (url, data) => {
        const fd = new FormData()

        fd.append("data", data)
        fd.append("filename", `PDF Files-${cuid()}.zip`)

        return axios({
            url,
            method: 'POST',
            responseType: 'blob',
            data: fd
        })
    }
    doGetDownloadUrlForOffice365 = (docid) => {
        // 添加token:phantomOnline，对应key为：POdfD8JD46DU
        // sign参数为token+ docId + key的md5加密值（不需要加号）

        let data = qs.stringify({
            docid: docid,
            sign: md5(`${commonToken}${docid}POdfD8JD46DU`).toString()
        });
        let url = `${this.CPDFURI}/${WebToolAPIs.download}?access_token=${commonToken}&${data}`;
        
        return url;
    }
}